import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Immutable from 'immutable';
import c from 'classnames';
import {
  ImmutableEntity,
  ImmutableRootState,
  GenericField,
  OptionalArrayField,
} from '@uncinc/react-drupal-core/types';

import {
  View,
} from '@uncinc/react-drupal-core';

import { BlockRelatedContent } from '../../../types/uncinc_profile/blocks';
import EntitiesHighlighted from '../../../components/EntitiesHighlighted';

interface RelatedContentBlockProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<BlockRelatedContent>;
  children?: JSX.Element;
  link: GenericField<string>;
  linkTitle: GenericField<string>;
  viewId: GenericField<string>;
  viewDisplay: GenericField<string>;
  viewFilters: GenericField<object>;
  viewArgs: OptionalArrayField<[GenericField<string>]>;
}

interface Entity { paths: Immutable.Map<string, string> }
interface EntityMap<E> extends Immutable.Map<number, ImmutableEntity<E>> { }

const RelatedContentBlock: React.FC<RelatedContentBlockProps> = ({
  entity, link, linkTitle, viewId, viewDisplay, viewFilters, viewArgs = [],
}) => {
  const { t } = useTranslation();
  const block = entity.toJS();
  const title = block.info[0].value;
  const body = block.body[0]?.processed;

  const viewEntities = useSelector<ImmutableRootState<EntityMap<Entity>>, EntityMap<Entity>>(
    (state) => state.getIn(['view', viewId, viewDisplay, 'entities'], Immutable.Map()),
  );

  const classnames = c('RelatedContentBlock', {
    hidden: viewEntities && viewEntities.size === 0,
  });

  const props: any = {};
  if (link) {
    props.link = link;
    props.linkTitle = linkTitle || t('content_types.default.overview');
  }

  return (
    <div className={classnames}>
      <EntitiesHighlighted
        title={title}
        body={body}
        {...props}
      >
        <View
          id={viewId}
          display={viewDisplay}
          filters={viewFilters}
          args={viewArgs}
        />
      </EntitiesHighlighted>
    </div>
  );
};

export default RelatedContentBlock;
